var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/utils/convertConditionsForForm.ts";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import { emptyFormCondition, filterOperatorList } from "../constants";
export var convertConditionsForForm = function convertConditionsForForm(conditions) {
  return conditions.length ? conditions.map(function (_ref) {
    var filterCondition = _ref.filterCondition,
        propertyGroupName = _ref.propertyGroupName,
        propertyName = _ref.propertyName,
        value = _ref.value;
    var currentOperator = filterOperatorList.find(function (_ref2) {
      var value = _ref2.value;
      return value === filterCondition;
    }) || null;
    return {
      operator: currentOperator,
      property: {
        groupName: propertyGroupName,
        name: propertyName,
        id: Math.floor(Math.random() * 10 + 1)
      },
      value: value
    };
  }) : [emptyFormCondition];
};